export enum SettingsPageTabsEnum {
  API_KEYS = "api-keys",
  OFF_DAYS = "off-days",
  // LANGUAGES = "languages",
  EMAIL_PROVIDERS = "email-providers",
  SMS_PROVIDERS = "sms-providers",
  CONTACTS_SETTINGS = "contacts-settings",
  USERS = "users",
}
